export default "__VITE_ASSET__C082CCkI__";